import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { 
  ArrowLeft,
  Eye,
  UserPlus,
  MessageCircle,
  Users,
  CheckCircle2,
  Download
} from "lucide-react";

const mockLogs = [
  { id: "1", acao: "view_profile", talento: "Maria S.", data: "28/01/2026", hora: "14:32" },
  { id: "2", acao: "add_shortlist", talento: "João P.", data: "28/01/2026", hora: "11:20" },
  { id: "3", acao: "request_contact", talento: "Ana L.", data: "27/01/2026", hora: "16:45" },
  { id: "4", acao: "view_profile", talento: "Carlos M.", data: "27/01/2026", hora: "10:15" },
  { id: "5", acao: "view_profile", talento: "Maria S.", data: "26/01/2026", hora: "09:30" },
];

const acaoConfig: Record<string, { label: string; icon: any; color: string }> = {
  view_profile: { label: "Visualizou perfil", icon: Eye, color: "text-blue-600" },
  add_shortlist: { label: "Adicionou à shortlist", icon: UserPlus, color: "text-green-600" },
  request_contact: { label: "Solicitou contato", icon: MessageCircle, color: "text-purple-600" },
};

export default function EmpresaAuditoria() {
  const navigate = useNavigate();

  return (
    <div className="page-container-desktop">
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        className="flex items-center justify-between mb-8"
      >
        <div className="flex items-center gap-4">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate("/empresa/relatorios")}
          >
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <div>
            <h1 className="font-heading text-2xl font-bold text-foreground">
              Auditoria de Acesso
            </h1>
            <p className="text-muted-foreground text-sm mt-1">
              Histórico de ações no portal
            </p>
          </div>
        </div>
        <Button variant="outline">
          <Download className="w-4 h-4" />
          Exportar
        </Button>
      </motion.div>

      {/* Filters */}
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
        className="flex gap-4 mb-6"
      >
        <select className="h-10 px-3 rounded-xl border border-input bg-background text-sm">
          <option value="">Todas as ações</option>
          <option value="view_profile">Visualização de perfil</option>
          <option value="add_shortlist">Adição a shortlist</option>
          <option value="request_contact">Solicitação de contato</option>
        </select>
        <select className="h-10 px-3 rounded-xl border border-input bg-background text-sm">
          <option value="">Últimos 30 dias</option>
          <option value="7">Últimos 7 dias</option>
          <option value="90">Últimos 90 dias</option>
        </select>
      </motion.div>

      {/* Logs */}
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
        className="bg-card rounded-2xl border border-border overflow-hidden"
      >
        <table className="w-full">
          <thead className="bg-muted/50">
            <tr>
              <th className="text-left text-xs font-medium text-muted-foreground p-4">Ação</th>
              <th className="text-left text-xs font-medium text-muted-foreground p-4">Talento</th>
              <th className="text-left text-xs font-medium text-muted-foreground p-4">Data</th>
              <th className="text-left text-xs font-medium text-muted-foreground p-4">Hora</th>
            </tr>
          </thead>
          <tbody>
            {mockLogs.map((log, i) => {
              const config = acaoConfig[log.acao];
              const Icon = config.icon;
              return (
                <tr key={log.id} className={i < mockLogs.length - 1 ? "border-b border-border" : ""}>
                  <td className="p-4">
                    <div className="flex items-center gap-2">
                      <Icon className={`w-4 h-4 ${config.color}`} />
                      <span className="text-sm text-foreground">{config.label}</span>
                    </div>
                  </td>
                  <td className="p-4">
                    <span className="text-sm text-foreground">{log.talento}</span>
                  </td>
                  <td className="p-4 text-sm text-muted-foreground">{log.data}</td>
                  <td className="p-4 text-sm text-muted-foreground">{log.hora}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </motion.div>

      {/* Info */}
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
        className="bg-primary/5 rounded-xl p-4 border border-primary/10 mt-6"
      >
        <p className="text-xs text-muted-foreground">
          Todos os acessos são registrados para garantir conformidade com LGPD e governança da plataforma.
        </p>
      </motion.div>
    </div>
  );
}
